var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loginPage"},[_c('div',{staticClass:"loginWrap"},[_c('img',{staticClass:"loginLogo",attrs:{"src":require("@/render/assets/images/login_logo.png")}}),_c('login-form',{attrs:{"data":_vm.loginInfo},on:{"submit":_vm.onLogin,"onRegister":_vm.handleRegister,"onForget":_vm.handleForget}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }